import { InjectionToken } from '@angular/core';

export const ALLOWED_IMAGES_FORMATS = new InjectionToken<string[]>('ALLOWED_IMAGES_FORMATS');
export const ALLOWED_DOCUMENTS_FORMATS = new InjectionToken<string[]>('ALLOWED_DOCUMENTS_FORMATS');

export const DefaultMomentAdapter = new InjectionToken<string[]>('DefaultMomentAdapter');
